import { render, staticRenderFns } from "./CascaderItem.vue?vue&type=template&id=242815a4&scoped=true&"
import script from "./CascaderItem.vue?vue&type=script&lang=js&"
export * from "./CascaderItem.vue?vue&type=script&lang=js&"
import style0 from "./CascaderItem.vue?vue&type=style&index=0&id=242815a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242815a4",
  null
  
)

export default component.exports